module.exports = __webpack_public_path__ + "static/media/icon-R.3ea6dc32.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/icon-R.png
// module id = 81
// module chunks = 0